export default "__VITE_ASSET__cf94e094__"